import SectionMessage from './SectionMessage';

export default SectionMessage;
